import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { PageTitle } from 'components/PageTitle';

import StaticLayout from 'containers/Layouts/StaticLayout/StaticLayout';

import { selectors } from 'store/app';

const Wrapper = styled.main`
  margin-top: 50px;
  font-size: 18px;
  text-align: center;
`;

const NotFound = () => {
  const history = useHistory();
  const homeOrLoginPage = useSelector(selectors.getHomeOrLoginPage);

  return (
    <StaticLayout showHeader={true}>
      <PageTitle title="Not found" />
      <Wrapper>
        <strong role="alert">
          Page not found.{' '}
          <button
            className="link link_underlined"
            type="button"
            onClick={() => history.push(homeOrLoginPage)}
          >
            Go Back
          </button>
        </strong>
      </Wrapper>
    </StaticLayout>
  );
};

export default NotFound;
